module.exports = __webpack_public_path__ + "media/images/area/area_miyazakiM400-9843dd379186a65255ca6720423b23b6.jpg";